import React from 'react';
import { Calendar } from 'lucide-react';

// ⚙️ Datum zahájení sezóny - upravte zde v kódu
const SEASON_OPENING_DATE = '30. 4. 2026';

// ⚙️ Seznam akcí
const EVENTS = [
  { name: 'Leden', date: '', event: 'nepravidelný provoz', time: '' },
  { name: 'Únor', date: '', event: 'nepravidelný provoz', time: '' },
  { name: 'Březen', date: '', event: 'nepravidelný provoz', time: '' },
  { name: 'Duben', date: 'Čtvrtek 30.4.2026', event: 'Pálení Čarodějnic 🧙‍♀️', time: '17:00' },
  { name: 'Květen', date: 'Sobota 30.5.2026', event: 'Dětský den 🥳', time: '16:00' },
  { name: 'Červen', date: 'Sobota 20.6.2026', event: 'Vodo-lodní soutěž 🛶', time: '13:00' },
  { 
    name: 'Červenec', 
    subEvents: [
      { date: 'Sobota 4.7.2026', event: 'Letní karneval & ATOM-ROCK 💿', time: '20:00' },
      { date: 'Sobota 18.7.2026', event: 'Makrely & posezení s hudbou 🐟🎸', time: '15:00' }
    ]
  }, 
  { 
    name: 'Srpen', 
    subEvents: [
      { date: 'Sobota 15.8.2026', event: 'Soutěž ve vaření kotlíkového guláše & Karamel Music Band 🍲', time: '15:00' },
      { date: 'Sobota 29.8.2026', event: 'Ukončení prázdnin 🎒', time: '16:00' }
    ]
  }, 
  { name: 'Září', date: '', event: 'pravidelný provoz', time: '' },
  { name: 'Říjen', date: '', event: 'nepravidelný provoz', time: '' },
  { name: 'Listopad', date: '', event: 'nepravidelný provoz', time: '' },
  { name: 'Prosinec', date: '', event: 'nepravidelný provoz', time: '' },
];

const EventCard = ({ name, date, event, time, subEvents }) => {
  return (
    <div className="bg-gray-50 rounded-lg p-6 hover:shadow-md transition-shadow">
      <h3 className="text-xl font-bold text-gray-800 mb-3 flex items-center gap-2">
        <span className="text-blue-600">📅</span>
        {name}
      </h3>
      
      {/* Pokud má měsíc více akcí (případ srpna) */}
      {subEvents && subEvents.length > 0 ? (
        <div className="space-y-6 pl-9">
          {subEvents.map((sub, idx) => (
            <div key={idx} className={idx > 0 ? "pt-4 border-t border-gray-200" : ""}>
              <p className="text-lg text-gray-800 font-semibold">{sub.date}</p>
              <p className="text-gray-800 my-1">{sub.event}</p>
              <p className="text-gray-600 text-sm">začátek v {sub.time} hod.</p>
            </div>
          ))}
        </div>
      ) : (
        /* Pokud má měsíc jen jednu nebo žádnou akci */
        <div className="pl-9">
          {date || event || time ? (
            <div className="space-y-1">
              {date && <p className="text-lg text-gray-800 font-semibold">{date}</p>}
              {event && <p className="text-gray-800">{event}</p>}
              {time && <p className="text-gray-600">začátek v {time} hod.</p>}
            </div>
          ) : (
            <p className="text-gray-400 italic">— bez akce —</p>
          )}
        </div>
      )}
    </div>
  );
};

const Akce = () => {
  return (
    <section className="py-16 px-4 bg-white min-h-screen" data-testid="akce-section">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-16">
          <Calendar className="w-16 h-16 mx-auto text-blue-600 mb-4" />
          <h2 className="text-4xl font-bold text-gray-800 mb-8">⚓ AKCE 2026 ⚓</h2>
          
          {/* Elegant Season Opening */}
          <div className="relative inline-block">
            <p className="text-sm uppercase tracking-[0.3em] text-blue-600 font-semibold mb-2">
              Zahájení sezóny
            </p>
            <p className="text-5xl md:text-6xl font-bold text-gray-800 mb-2">
              {SEASON_OPENING_DATE}
            </p>
            <div className="flex items-center justify-center gap-3 mt-3">
              <div className="h-px w-12 bg-blue-600"></div>
              <span className="text-blue-600 text-2xl">⚓</span>
              <div className="h-px w-12 bg-blue-600"></div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          {EVENTS.map((evt, idx) => (
            <EventCard
              key={`${evt.name}-${idx}`}
              name={evt.name}
              date={evt.date}
              event={evt.event}
              time={evt.time}
              subEvents={evt.subEvents}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Akce;
